import { Checkbox } from '@ksyos/design-system';
import { CardiologyMedicationLabel } from '@common/validation/customControls/cardiology/holter/utils/medicationUtils';
import type { CheckboxItem } from './HolterMedicationSelector';
import { PlaatjesRemmersTooltipLabel } from './PlaatjesRemmersToolTip';

export function MedicationCheckbox(
    props: Readonly<{
        ariaLabel: string;
        checkBoxItem: CheckboxItem;
    }>
) {
    const { isChecked, value, textInputValue, checkboxLabel, onChangeHandler, disabled, indeterminate, onChangeText } =
        props.checkBoxItem;
    const { ariaLabel } = props;
    const includesTextField = checkboxLabel === CardiologyMedicationLabel.overige;

    return (
        <Checkbox
            checked={includesTextField ? isChecked : Boolean(value)}
            disabled={disabled}
            indeterminate={indeterminate}
            label={<PlaatjesRemmersTooltipLabel label={checkboxLabel} />}
            onChange={onChangeHandler}
            textInput={
                checkboxLabel === CardiologyMedicationLabel.overige
                    ? {
                          'aria-label': ariaLabel,
                          onChange: onChangeText,
                          value: textInputValue ?? '',
                      }
                    : undefined
            }
        />
    );
}
